import DynamicButton from "../../DynamicButton/DynamicButton";

const TableBulkActionBar = ({ selectedRows, handleBulkDelete }) => {
  if (selectedRows.length === 0) return null;

  return (
    <DynamicButton
      text={`(${selectedRows.length})`}
      icon="fa-trash"
      variant="danger"
      size="md"
      onClick={handleBulkDelete}
    />
  );
};

export default TableBulkActionBar;
